import React from "react";
import { useForm } from 'react-hook-form/dist/react-hook-form.ie11';
import PersonalHistory from "./PersonalHistory";
import MedicalHistory from "./MedicalHistory";
import BackNext from "../../Common/SubComponents/BackNext";
import { Row, Col, Container } from "react-bootstrap";
import PropTypes from 'prop-types';
import { object } from 'yup';

export default function PersonalMedicalHistory(props) {
    const { fullFormState, basicInfo, onFieldChange, onMultiFieldChange } = props;

    const { register, errors, handleSubmit, setValue, triggerValidation } = useForm({
        validationSchema: PersonalMedicalHistory.ValidationSchema,
        mode: 'onBlur',
        reValidateMode: 'onBlur',
    });

    return (
        <Container>
            <form className="quote-form" onSubmit={handleSubmit(props.onNext)}>
                <Row className='formPage justify-content-center'>
                    <Col lg={6}>
                        <PersonalHistory
                            formState={fullFormState.steps.personalHistory}
                            onFieldChange={(field, value) => onFieldChange('personalHistory', field, value)}
                            basicInfo={basicInfo}
                            register={register}
                            errors={errors}
                            setValue={setValue}
                            triggerValidation={triggerValidation}
                        />
                        <MedicalHistory
                            formState={fullFormState.steps.medicalHistory}
                            onFieldChange={(field, value) => onFieldChange('medicalHistory', field, value)}
                            basicInfo={basicInfo}
                            fullFormState={fullFormState}
                            onMultiFieldChange={onMultiFieldChange}
                            register={register}
                            errors={errors}
                            setValue={setValue}
                            triggerValidation={triggerValidation}
                        />
                    </Col>
                </Row>
                <BackNext onBack={props.onBack} colSize={2} continueLabel={{ text: 'Next' }} />
            </form>
        </Container>
    );
}

PersonalMedicalHistory.ValidationSchema = object().shape({ ...PersonalHistory.ValidationSchema.fields, ...MedicalHistory.ValidationSchema.fields });

PersonalMedicalHistory.propTypes = {
  fullFormState: PropTypes.object,
  onFieldChange: PropTypes.func,
  onMultiFieldChange: PropTypes.func,
  basicInfo: PropTypes.object
};



// WEBPACK FOOTER //
// ./src/components/Quoters/AmericoLoanProtection/steps/PersonalMedicalHistory.js